import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { delayRetrieveTasks } from './store/actions/search';

import { clearFilters } from './store/actions/query';
import Filters from './filters';

export class MobileTaskFilters extends React.Component {
  static propTypes = {
    delayRetrieveTasks: PropTypes.func.isRequired,
    onClearFilters: PropTypes.func.isRequired,
    onCloseFilters: PropTypes.func.isRequired
  };

  handleClearFilters = () => {
    const { onClearFilters, delayRetrieveTasks } = this.props;
    onClearFilters();
    delayRetrieveTasks();
  }


  render() {
    const { onCloseFilters } = this.props;

    return (
      <>
        <button className="btn close-filters-btn btn-ghost" onClick={this.handleClearFilters}>Clear Filters</button>
        <Filters
          hideSearchTextFilter
          mobileView
          name='task-filters'
        />
        <button className="btn btn-primary mt-2" onClick={onCloseFilters}>View Tasks</button>
      </>
    );
  }
}

const mapDispatchToProps = {
  delayRetrieveTasks,
  onClearFilters: clearFilters
};

export default connect(() => ({}), mapDispatchToProps)(MobileTaskFilters);
